import { Dispatch, SetStateAction, useEffect, useState } from 'react';

type ResponseProps<T> = [T, Dispatch<SetStateAction<T>>];

const usePersistedState = <T>(
  key: string,
  initialValue: T,
): ResponseProps<T> => {
  const [state, setState] = useState(() => {
    const storageValue = localStorage.getItem(key);

    return storageValue ? JSON.parse(storageValue) : initialValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
};

export default usePersistedState;
